import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { defaultTo } from 'ramda';

export function getMasterAgent({ masterAgent }: IAgentSchema) {
  return defaultTo(undefined, masterAgent);
}
